import axios from "@/axios.js";
import ClientFields from "./client_fields_service";

export default {
  getAllClientFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      ClientFields.getAllClientFields(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchFields(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/client_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeClientField(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/fields/client_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingFieldLists(context, field_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/client_fields/get_client_existing_field_lists/${field_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/client_fields/update_client_field", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/client_fields/add_fields", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeFields({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/fields/client_fields/${roleId}`)
        .then(response => {
          commit("REMOVE_STEPS", roleId);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
